import React from "react";
import {
  FooterAgencyInformation,
  FooterAgencyInformationColumn,
  FooterAgencyInformationInfo
} from '@utahdts/utah-design-system';
import logo from "../../../images/DDW_LOGOS/ddw_bw_logo.png";
import "./Footer.css";

const Footer = () => {
  const isAuthenticated = localStorage.getItem("auth") === "true";
  return (
    <footer id="app-footer" aria-label="Utah Design System (main footer)">
      <FooterAgencyInformation>
        <FooterAgencyInformationColumn>
          <FooterAgencyInformationInfo 
            address={{
              city: 'Salt Lake City',
              state: 'UT',
              streetAddress1: '195 North 1950 West',
              zipCode: '84116',
              }}
              agencyTitleFirstLine="Utah Department of Environmental Quality | Drinking Water"
            email="ddwreports@utah.gov"
            logo={<img src={logo} alt="Division of Technology Services" />}
          />
          <span>Office: (801) 536-4200</span>
          <br />
          <br />
          {isAuthenticated && <a className="report-bug" href="https://forms.gle/2kqqk61WBRVbGTQY6" target="_blank" rel="noopener noreferrer" aria-label="Report a Bug (opens in new tab)">Report a Bug</a>}
        </FooterAgencyInformationColumn>
      </FooterAgencyInformation>
      
    </footer>
  );
};

export default Footer;
